"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedFieldSchema = exports.LocaleEnum = void 0;
const zod_1 = __importDefault(require("zod"));
exports.LocaleEnum = zod_1.default.enum(['en', 'th']);
exports.LocalizedFieldSchema = zod_1.default.object({
    en: zod_1.default.string().default(''),
    th: zod_1.default.string().default(''),
});
